import * as api from '../../services/invoice'

export const FETCH_INVOICES = 'FETCH_INVOICES';
export const FETCH_INVOICE = 'FETCH_INVOICE';
export const FETCH_INVOICE_STATS = 'FETCH_INVOICE_STATS';
export const FETCH_ATTENDEE_INVOICES = 'FETCH_ATTENDEE_INVOICES';


export const fetchInvoice = (userId, invoiceId) => {
    return {
        type: FETCH_INVOICE,
        payload: {
            promise: api.findInvoice({userId: userId, invoiceId: invoiceId})
        }
    }
}


export const fetchInvoices = (params, pagination, sort, extra) => {
    return {
        type: FETCH_INVOICES,
        payload: {
            promise: api.findInvoices(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}

export const fetchInvoiceStats = (userId) => {
    return {
        type: FETCH_INVOICE_STATS,
        payload: {
            promise: api.findUserInvoiceStats({userId: userId})
        }
    }
}

export const fetchAttendeeInvoices = (params, pagination, sort, extra) => {
    return {
        type: FETCH_ATTENDEE_INVOICES,
        payload: {
            promise: api.findAttendeeInvoices(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/invoice.js